import { LoadingCartFullPage } from 'src/components';
import { useCurrentUser } from 'src/hooks';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { isPending, error } = useCurrentUser();

  if (isPending) {
    return <LoadingCartFullPage />;
  }

  if (error) {
    console.error(`Error getting user`);
  }

  return <>{children}</>;
};
